import { createContext, useContext, type ReactNode } from "react";
import type { ModuleManifest } from "@praesto/contracts";

/**
 * Manifests live in Boot's React state (loaded once after auth + tenant
 * settings). AppLayout reads them via this context — fetching again
 * inside the layout created a race where SubNavSidebar briefly rendered
 * with `manifests=[]` between mount and the useEffect resolving, so the
 * second-level sidebar visually flickered empty on every reload.
 */
const ManifestsContext = createContext<ReadonlyArray<ModuleManifest> | null>(null);

export function ManifestsProvider({
  manifests,
  children,
}: {
  manifests: ReadonlyArray<ModuleManifest>;
  children: ReactNode;
}) {
  return (
    <ManifestsContext.Provider value={manifests}>
      {children}
    </ManifestsContext.Provider>
  );
}

export function useManifests(): ReadonlyArray<ModuleManifest> {
  const ctx = useContext(ManifestsContext);
  if (ctx === null) {
    throw new Error("useManifests called outside ManifestsProvider");
  }
  return ctx;
}
